import type { DealCatalog } from "../../deal-protocol/src";
import { candidateThemeBundle } from "./candidate-theme-selection";
export type {
  CandidateCardDefinition,
  CandidateIcebreaker,
  CandidateThemeDefinition,
  LocalizedCandidateText
} from "./candidate-theme-types";

export const RETRO_CINEMA_CANDIDATE_CATALOG_REVISION =
  "catalog.retro-cinema.candidate-6";

export const retroCinemaCandidateTheme = candidateThemeBundle("cinema").theme;

export const retroCinemaCandidateCatalog: DealCatalog = {
  catalogRevision: RETRO_CINEMA_CANDIDATE_CATALOG_REVISION,
  themes: [retroCinemaCandidateTheme]
};
